import { render, staticRenderFns } from "./AppPopup.vue?vue&type=template&id=627e7a4e&scoped=true&"
import script from "./AppPopup.vue?vue&type=script&lang=js&"
export * from "./AppPopup.vue?vue&type=script&lang=js&"
import style0 from "./AppPopup.vue?vue&type=style&index=0&id=627e7a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e7a4e",
  null
  
)

export default component.exports